import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { HubService } from '../services/hub.service';
import { Hub } from '../types/hub';
import { HubHealth } from '../types/hubhealth';

@Component({
  selector: 'hub-detail',
  templateUrl: './hub-detail.component.html',
  styleUrls: ['./hub-detail.component.css'],
  providers: [HubService],
})

export class HubDetailComponent implements OnInit {
  hub: Hub;
  health: HubHealth[];
  errorMessage: string;
  heatingStateDescription: string;
  supersededBy: number;

  constructor(
    private api: ApiService,
    private hubService: HubService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }

    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getHub(+params['hubid']))
    ).subscribe(
      (hub: Hub) => this.setHub(hub),
      error => this.errorMessage = <any>error,
    );
  }

  setHub(hub: Hub) {
    this.hub = hub;
    this.hub.serial = Hub.HubIDToSerial(hub.hubid);
    this.supersededBy = 0;
    if (this.hub.machineid.match(/^[A-F0-9]{8}-([A-F0-9]{4}-){3}[A-F0-9]{12}_\d{4}-.*$/i)) {
      this.hubService.getHub(this.hub.machineid.substring(0, 36))
        .subscribe(
          newHub => this.supersededBy = newHub.hubid,
          error => this.errorMessage = <any>error,
        );
    }
    AppComponent.SetTitle(hub.name + ' (' + hub.hubid + ')');
    if (hub.holiday) {
      this.heatingStateDescription = 'Holiday Mode';
    } else if (hub.heating) {
      this.heatingStateDescription = (hub.heating === 2 ? 'Boost' : 'On') + ` with boiler ` + (hub.boiler ? 'ON' : 'OFF');
    } else {
      this.heatingStateDescription = 'OFF';
    }
  }

  lastSeenClass(): string {
    let seen = Date.parse(this.hub.last_seen);
    let now = Date.now();
    if (seen > (now - 7200000)) { return 'seen_last_2'; }
    if (seen > (now - 28800000)) { return 'seen_last_8'; }
    return 'not_seen_recently';
  }

  goBack(): void {
    this.location.back();
  }

  gotoSuperseded(): void {
    if (!this.router.navigate(['/hub', this.supersededBy])) {
      console.log('Navigation failed.');
    }
  }
}
